import React, { useEffect, useState } from 'react';
import { COLORS } from '../config/constants';

const SplashScreen = ({ onComplete }) => {
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setFadeOut(true);
      setTimeout(onComplete, 500);
    }, 2500);

    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <div
      data-testid="splash-screen"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100vh',
        background: `linear-gradient(135deg, ${COLORS.primary} 0%, ${COLORS.secondary} 100%)`,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
        opacity: fadeOut ? 0 : 1,
        transition: 'opacity 0.5s ease-in-out'
      }}
    >
      {/* Logo */}
      <img 
        src="/abell-logo.svg" 
        alt="Abell Logo" 
        style={{
          width: '180px',
          height: 'auto',
          marginBottom: '2rem',
          filter: 'drop-shadow(0px 4px 12px rgba(0,0,0,0.3))'
        }}
      />

      {/* Company Name */}
      <h1
        style={{
          fontSize: '3.5rem',
          fontWeight: '700',
          color: COLORS.white,
          marginBottom: '1rem',
          letterSpacing: '2px'
        }}
      >
        ABELL
      </h1>

      {/* Tagline */}
      <p
        style={{
          fontSize: '1.25rem',
          fontWeight: '300',
          color: COLORS.white,
          textAlign: 'center',
          maxWidth: '600px',
          opacity: 0.9
        }}
      >
        Enerjiyi Hayal Et, Geleceği Tasarla
      </p>

      <style>{`
        @keyframes pulse {
          0%, 100% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.05);
          }
        }
      `}</style>
    </div>
  );
};

export default SplashScreen;